import { render } from "./MModal.vue?vue&type=template&id=dd084d0a&scoped=true"
import script from "./MModal.vue?vue&type=script&lang=js"
export * from "./MModal.vue?vue&type=script&lang=js"

import "./MModal.vue?vue&type=style&index=0&id=dd084d0a&lang=scss&scoped=true"
import "./MModal.vue?vue&type=style&index=1&id=dd084d0a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd084d0a"]])

export default __exports__